<template>
  <button
    :aria-label="`${$t('accessibility.open_folder')}: ${data.title}`"
    class="group flex w-full justify-between py-3 pl-4 pr-6 text-left text-md font-medium transition hover:bg-[#F6FBFD]"
    @click="openFolder"
  >
    <span class="flex items-center">
      <FolderIcon class="mr-3 w-6 text-blue-800" />

      {{ data.title }}
    </span>

    <span
      class="text-base text-blue-800 opacity-0 transition-opacity group-hover:opacity-100"
    >
      {{ $t('open') }}
    </span>
  </button>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
})

const queryScope = inject('queryScope', 'downloads-area')

const route = useRoute()
const router = useRouter()

const openFolder = () => {
  const queryDownloadArea = route.query[queryScope]
    ? JSON.parse(route.query[queryScope])
    : { level: 0 }

  router.push({
    query: {
      ...router.currentRoute.value.query,
      [queryScope]: JSON.stringify({
        level: parseInt(queryDownloadArea.level) + 1,
        id: props.data.id,
      }),
    },
  })
}
</script>
